// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"e4e02caf","17":"ac23256a","185":"355fda38","488":"c51013ff","523":"237a10b0","555":"8b1aa8c5","741":"a6a7a033","755":"cc23b676","895":"ca163495"}[chunkId] + ".chunk.js";
};